import { render, staticRenderFns } from "./AbpTableForFunctional.vue?vue&type=template&id=8bebb104&scoped=true&"
import script from "./AbpTableForFunctional.vue?vue&type=script&lang=ts&"
export * from "./AbpTableForFunctional.vue?vue&type=script&lang=ts&"
import style0 from "./AbpTableForFunctional.vue?vue&type=style&index=0&id=8bebb104&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bebb104",
  null
  
)

export default component.exports